export function flattenObject(values: Record<string, any>, path?: string) {
    let newValues: Record<string, any> = {};

    for (const valuesKey in values) {
        const x = values[valuesKey];
        const newKey = path ? `${path}.${valuesKey}` : valuesKey;

        if (Array.isArray(x)) {
            newValues = { ...newValues, [newKey]: x.join(',') };
        } else if (typeof x === 'object') {
            newValues = { ...newValues, ...flattenObject(x, newKey) };
        } else {
            newValues[newKey] = x;
        }
    }

    return newValues;
}
